import React from 'react';

interface HeaderIconProps {
  isActive: boolean;
  width?: number;
  height?: number;
}

const defaultColor = '#ffffff';
const activeColor = '#54C3F1';

export const ItemIcon: React.FC<HeaderIconProps> = ({ isActive, width = 15, height = 15 }) => {
  const color = isActive ? activeColor : defaultColor;
  return (
    <svg width={width} height={height} viewBox="0 0 70 70" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M53.64,33.75c.68,0,1.23.57,1.23,1.25,0,.67-.54,1.22-1.21,1.23,0,0-.01,0-.02,0h-17.41v15.3c0,.67-.54,1.22-1.21,1.23,0,0-.01,0-.02,0-.69.03-1.26-.51-1.29-1.19,0-.01,0-.02,0-.03v-15.33h-17.36c-.65.02-1.2-.5-1.22-1.15,0-.01,0-.03,0-.04,0-.67.54-1.22,1.21-1.23,0,0,.01,0,.02,0h17.35v-15.31c0-.67.55-1.22,1.23-1.23.67-.04,1.25.47,1.29,1.14,0,.03,0,.06,0,.09v15.28h17.41Z"
        fill={color}
      />
    </svg>
  );
};

export const ReportIcon: React.FC<HeaderIconProps> = ({ isActive, width = 15, height = 15 }) => {
  const color = isActive ? activeColor : defaultColor;
  return (
    <svg width={width} height={height} viewBox="0 0 70 70" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M38.47,6.44c-.93-.93-2.16-1.44-3.47-1.44-2.71,0-4.91,2.2-4.91,4.91v.68h-3.17c-1.88,0-3.41,1.53-3.41,3.41v.03h-8.19c-.55,0-1,.45-1,1v48.98c0,.55.45,1,1,1h39.35c.55,0,1-.45,1-1V15.02c0-.55-.45-1-1-1h-8.19v-.03c0-1.88-1.53-3.41-3.41-3.41h-3.17v-.68c0-1.32-.51-2.56-1.44-3.47ZM32.09,9.91c0-1.6,1.3-2.91,2.91-2.91.77,0,1.5.3,2.06.86.55.54.85,1.27.85,2.05v.68h-5.81v-.68ZM53.68,16.02v46.98H16.32V16.02h7.19v2.44c0,.55.45,1,1,1h20.97c.55,0,1-.45,1-1v-2.44h7.19ZM44.49,13.99v3.47h-18.97v-3.47c0-.78.63-1.41,1.41-1.41h16.16c.78,0,1.41.63,1.41,1.41Z"
        fill={color}
      />
    </svg>
  );
};

export const ApprovalIcon: React.FC<HeaderIconProps> = ({ isActive, width = 15, height = 15 }) => {
  const color = isActive ? activeColor : defaultColor;
  return (
    <svg width={width} height={height} viewBox="0 0 70 70" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.54,23.03h-10.22c-1.09,0-2.24.87-2.24,1.96v20.02c0,1.09,1.18,1.73,2.24,1.96h10.22l23.34,10.9V12.13l-23.34,10.9Z"
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M54.69,20.82c2.71,3.76,4.23,8.86,4.23,14.18s-1.52,10.42-4.23,14.18"
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
};

export const SettingIcon: React.FC<HeaderIconProps> = ({ isActive, width = 15, height = 15 }) => {
  const color = isActive ? activeColor : defaultColor;
  return (
    <svg width={width} height={height} viewBox="0 0 70 70" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M55.78,18.44l-4.21-4.21c-.86-.86-2.25-.86-3.1,0L15.78,46.9h0l-2.17,8.11c-.16.6.19,1.21.79,1.37.1.03.2.04.3.04.1,0,.2-.01.29-.04l8.11-2.16h0L55.78,21.54c.86-.86.86-2.25,0-3.11,0,0,0,0,0,0ZM46.79,18.37l4.9,4.78-29.02,29.02-4.91-4.78,29.02-29.02ZM17.01,49.09l3.99,3.88-5.4,1.44,1.41-5.32ZM54.54,20.3l-1.6,1.6-4.91-4.78,1.67-1.67c.17-.17.45-.18.62,0,0,0,0,0,0,0l4.22,4.22c.17.17.17.45,0,.63Z"
        fill={color}
      />
    </svg>
  );
};
